import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
    modal: {
        alignItems: 'center',
        flex: 1,
    },
    button: {
        marginTop: 32,
        width: '100%',
    },
    reward: {
        resizeMode: 'contain',
        marginTop: 50,
    },
    title: {
        marginTop: 50,
    },
    description: {
        textAlign: 'center',
        marginTop: 20,
    },
})

export default styles
